// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"2b1b90be","294":"ca4dbce9","391":"25dcb09e","410":"40c0b0c1","518":"05304bf5","618":"09fc2d94","640":"41cd7a45","854":"27b6c586"}[chunkId] + ".chunk.js";
};